import { createFileRoute } from '@tanstack/react-router'
import ManageBooking from '@/pages/manage-booking'

export const Route = createFileRoute('/manage-booking/')({
  component: ManageBooking,
})
